import { LoginApi } from "@/features/auth/services/login-api";
import { LoginPostRequestModel } from "@/features/auth/services/login-model";

/// ログイン画面処理
export class LoginService {
  private loginApi = new LoginApi();

  /**
   * ログインAPI実行
   */
  public async postLogin(param: LoginPostRequestModel) {
    return await this.loginApi.postLogin(param);
  }
}
